<template>
	<div @click="imageClick" class="goods-image-box" :style="imgSize">
        <img class="goods-image" :src="$util.img(imageInfo.sku_image || imageInfo.goods_image)" @error="goodsImageError()"/>
        <template v-if="returnActiveImage">
            <img class="goods-active-image" :src="$util.img(returnActiveImage)"/>
        </template>
        <template v-if="showLable">
            <div class="goods-label-box">
                <goods-code-label :goods="goods">
					<template #start>
						<goods-label :goods="goods"></goods-label>
					</template>
				</goods-code-label>
            </div>
        </template>
    </div>
</template>
<script>
import goodsLabel from "../goods-label/goods-label.vue";
import goodsCodeLabel from "../goods-label/goods-code-label.vue";
export default {
	name: "goods-list-item",
    components: {goodsLabel,goodsCodeLabel},
	props: {
		goods: {
			type: Object,
			required: true,
			default: ''
		},
		imageSize: {
			type: [Number, String],
			default: 200
		},
        showLable: {
            type: Boolean,
            default: false
        }
	},
	watch: {
		goods: {
			deep: true,
			handler() {
				let temObj = JSON.parse(JSON.stringify(this.goods));
				if(temObj.goods){
					temObj = Object.assign(temObj,temObj.goods);
				}
				this.imageInfo = temObj;
			}
		}
	},
	data() {
		return {
			imageInfo:{}
		}
	},
	 mounted() {
		let temObj = JSON.parse(JSON.stringify(this.goods));
		if(temObj.goods){
			temObj = Object.assign(temObj,temObj.goods);
		}
		this.imageInfo = temObj;
	},
	methods: {
		goodsImageError() {
			this.imageInfo.sku_image = this.$util.getDefaultImage().default_goods_img;
		},
		imageClick(){
			this.$emit('click',this.imageInfo);
		}
	},
	computed: {
		returnActiveImage(){
			return this.imageInfo.border_image || ''
		},
		imgSize() {
			return `width: ${this.imageSize}px;height: ${this.imageSize}px;max-width: ${this.imageSize}px;max-height: ${this.imageSize}px;`;
		}
	}
}
</script>


<style scoped lang="scss">
.goods-image-box{
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	flex-shrink: 0;
	object-fit: contain;
	box-sizing: border-box;
}
.goods-image {
	width: 100%;
	height: 100%;
	flex-shrink: 0;
	object-fit: contain;
	box-sizing: border-box;
	position: relative;
	z-index: 1;
}
.goods-active-image{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	flex-shrink: 0;
	object-fit: contain;
	box-sizing: border-box;
	z-index: 2;
}
.goods-label-box{
    position: absolute;
    left: 0;
    top: 0;
    height: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
    z-index: 3;
    >img{
        height: 100%;
    }
}
</style>
